import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contactnumber-capture',
  templateUrl: './contactnumber-capture.component.html',
  styleUrls: ['./contactnumber-capture.component.scss']
})
export class ContactnumberCaptureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  //TODO Added for AOT
  savedAdd
  radioValue
  line1
  coc
  filteredOptions
  onInput(e){}
  list = [
    1
  ]


}
